import React, {Component} from 'react';
import {Modal} from 'antd';
import Form from "../../../components/CustomForm";

export default class ChangePackage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
        this.content = [
            {
                name: '所属部门',
                type: 'input',
                dataIndex: 'name',
                labelCol: 8,
                required:true,
                wrapperCol: 14,
                message:'请填写所属部门'
            },
            {
                name: '是否展示',
                type: 'select',
                dataIndex: 'status',
                labelCol: 8,
                required: true,
                wrapperCol: 14,
                message: '请选择是否展示',
                option: [
                    {id: true, name: '展示'},
                    {id: false, name: '不展示'}
                ]
            },
        ]

    }

    onSubmit = () => {
        this.props.refreshList();
        this.setState({
            visible: false
        })
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    render() {

        return (
            <>
                <a onClick={() => {
                    this.setState({visible: true})
                }}>修改</a>
                <Modal
                    // width={window.innerWidth * 0.8}
                    title="修改"
                    visible={this.state.visible}
                    footer={null}
                    destroyOnClose={true}
                    onCancel={this.handleCancel}
                >
                    <Form
                        content={this.content} onSubmit={this.onSubmit} url={'/api/dept/save'}
                        values={this.props.item}
                        value={{id: this.props.item.id}}
                        checkNumber={true}
                    />
                </Modal>
            </>
        );
    }
}
